import TextInput from "@pathwright/ui/src/components/form/form-text-input/TextInput"
import View from "@pathwright/ui/src/components/ui/View"
import styled from "styled-components"

export const labelGray = "#888888"
export const black = "#000000"
export const offBlack = "#292e35"
export const mediumGray = "#555555"
export const white = "#ffffff"
export const offWhite = "#efefef"

export const hoveredShadow =
  "inset 0 0 0 2px white, 0 0 0 2px rgba(180, 180, 180, 0.5)"

export const StyleSwitcherContainer = styled(View.Primary)`
  position: relative;
  display: flex;
  padding: 18px;
  padding-bottom: 8px;
  top: 5px;
  left: -5px;
  border-radius: 8px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.18);
`

export const StyleToolWrapper = styled.div`
  padding: 0 10px;
`

export const StyleMenuWrapper = styled.div`
  p {
    margin: 10px 8px 8px;
  }

  .Button {
    height: auto !important;
    line-height: 1 !important;
  }

  .Button--flex-wrapper {
    flex-direction: row;
    padding-right: 15px;
  }
`

export const StyleMenu = styled(View.Primary)`
  display: flex;
  width: 100%;
  margin-bottom: 20px;

  .BlocksStyles__StyleItem:last-of-type {
    margin-right: 0 !important;
  }
`

export const StyleItem = styled.div`
  min-width: 40px;
  width: 100%;
  height: 30px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
  background-color: ${(props) => (props.selected ? mediumGray : white)};

  &:hover {
    background-color: ${(p) =>
      !p.applyHoverShadows && !p.selected ? offWhite : ""};
  }

  ${(p) =>
    p.applyHoverShadows
      ? `
    &:hover {
      box-shadow: ${hoveredShadow};
    }
  `
      : ""}

  i {
    font-size: 18px;
  }

  .Pathicon {
    color: ${(props) => (props.selected ? white : mediumGray)};
  }
`

export const DropdownButton = styled.div`
  cursor: pointer;
  position: relative;
  margin: 0px 5px 0px 18px;
  &:before {
    content: "";
    width: 1px;
    height: 100%;
    background-color: #aaa;
    position: absolute;
    left: -12px;
  }
`

export const ToolHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;

  span {
    color: ${labelGray};
  }

  .Pathicon {
    margin-right: 2px;
  }

  .IconButton {
    margin-right: 2px;
  }
`

// Custom Colors
export const ChooseColorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 250px;
  border-radius: 8px;
  padding-bottom: 18px;
`

export const ColorRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  width: 100%;

  .styled-field {
    display: none;
  }
`

export const InputLabel = styled.h5`
  margin-bottom: 0.3rem;
  margin-top: 0;
  font-size: 14.4px;
  color: ${labelGray};
  font-weight: 400;
`

export const ColorInput = styled(TextInput)`
  margin-right: 10px;

  .TextInput {
    padding-left: 0;
  }

  .TextInput__input input {
    padding: 5px 10px;
  }
`
